<!-- bonus.wxml -->
<template>
    <div class="member-donus-box">
        <!--  member  -->
        <div class="member-box clearfix">
            <div class="donus-box">
                <div class="title">可用积分</div>
                <div class="donus">{{userInfo.points}}</div>
            </div>
            <div class="all-donus">累计积分 {{member.all_donus}}</div>
            <image class="bg" src="../../images/member_bonus_bg.jpg" mode="widthFix"/>
        </div>
        <!--  member end -->
        <!-- tab -->
        <div class="type-tab skeleton-rect">
            <div v-for="(item,index) in typeList" :key="index"
                 :class="['tab-item',item.type == currType ? ' active':'']" @click="getType(item)">
                <div class="item">
                    {{item.name}}
                </div>
            </div>
        </div>
        <!-- tab end -->
        <!-- donus -->
        <div class="donus-list-box">
            <nut-infiniteloading
                v-if="!noresult"
                @loadmore="dounsLoadMore"
                :is-show-mod="true"
                :has-more="isHasMore"
                :is-loading="isLoading"
                :threshold="200"
            >
                <ul class="donus-list">
                    <li class="list-item clearfix" v-for="(item,index) in bonusList" :key="index">
                        <div class="title skeleton-rect">{{item.describe}}</div>
                        <div class="time skeleton-rect">{{item.create_time}}</div>
                        <div :class="['donus',currType==1 ? 'add':'remove']">{{currType==1 ? '+':''}}{{item.value}}
                        </div>
                    </li>
                </ul>
            </nut-infiniteloading>
            <!-- no-result -->
            <div class="noresult" v-if="noresult">
                <div class="cot">
                    <div class="img">
                        <img src="../../assets/images/no_result.png">
                    </div>
                    <p class="text" style="color: #aaa;">空空如也</p>
                </div>
            </div>
            <!-- no-result end -->
        </div>
        <!-- donus end -->
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
    export default {
        name: 'MemberBonus',
        data() { //默认数据
            return {
                noresult: false,
                isHasMore: true,
                isLoading: false,
                isErr: false,
                currType: 1,// 当前类型
                userInfo: {}, // 用户信息
                current_page: 1,
                last_page: 1,
                member: {
                    usable_donus: 0,
                    all_donus: 0,
                },
                typeList: [
                    {
                        name: '积分收入',
                        type: 1,
                    },
                    {
                        name: '积分支出',
                        type: 0,
                    }
                ],
                bonusList: [],
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.getUserDetail();
        },
        methods: {

            /**
             * 获取当前用户信息
             */
            getUserDetail() {
                let _this = this;
                _this._get('user.index/detail', {}, function (result) {
                    _this.userInfo = result.data.userInfo;
                    _this.getBonus(); // 获取积分列表
                    _this.getTotal(); // 获取总积分
                });
            },

            // 获取累计积分
            getTotal() {
                let _this = this;
                _this._get('user/totalPoints', {}, res => {
                    _this.member.all_donus = res.num;
                });
            },

            // 获取积分列表
            getBonus(page = 1) {
                let _this = this;
                _this._get('user/points', {
                    type: _this.currType == 1 ? 'add' : 'remove',
                    page: page
                }, res => {
                    _this.setData({
                        bonusList: _this.bonusList.concat(res.data),
                        current_page: res.current_page,
                        last_page: res.last_page,
                        noresult: res.data.length ? false : true,
                        isHasMore: res.data.length ? true : false
                    })
                    _this.isLoading = false;
                    _this.loading.hide();
                });
            },

            /**
             * 顶部切换事件
             */
            getType: function (item) {
                let _this = this;
                _this.loading = _this.$toast.loading('Loading...', {
                    coverColor: "rgba(0,0,0,0.5)",
                });
                _this.currType = item.type;
                _this.bonusList = [];
                _this.getBonus();
            },
            /**
             * 触底加载
             */
            dounsLoadMore: function () {
                if (this.current_page >= this.last_page) {
                    this.isLoading = false;
                    this.isHasMore = false;
                    return false;
                }
                this.isLoading = true;
                this.isHasMore = true;
                this.getBonus(this.current_page + 1);
            }
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss">
    @import "bonus.scss";
</style>
